import React, { useState, useEffect } from "react";
import {
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  CircularProgress,
} from "@material-ui/core";
import axios from "axios";
import { toast } from "react-toastify";
import { generateForm } from "src/helpers/functions";
import SingleCustomAutocomplete from "src/Components/CustomAutocomplete/SingleCustomAutocomplete";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const AddUpdateSpecialDates = ({
  visible,
  setVisible,
  formData,
  setFormData,
  getData,
}) => {
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [customers, setCustomers] = useState([]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const getCustomers = () => {
    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getCustomers`, {})
      .then(function (response) {
        setCustomers(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getData();

    if (customers.length == 0) getCustomers();
  }, []);

  const saveForm = () => {
    setSaveIsLoading(true);
    const submitFormData = generateForm(formData);
    const url =
      formData.id > 0
        ? `${process.env.REACT_APP_API}/admin/specialDates/update`
        : `${process.env.REACT_APP_API}/admin/specialDates/add`;

    axios
      .post(url, submitFormData)
      .then(() => {
        toast.success(
          formData.id > 0 ? "Updated successfully" : "Inserted successfully"
        );
        setSaveIsLoading(false);
        setVisible(false);
        getData();
      })
      .catch(() => {
        setSaveIsLoading(false);
        toast.error("Error While Saving");
      });
  };

  const handleClose = () => setVisible(false);

  const customOnChange = (newValue, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const updatedCustomers = customers.map((vender) => ({
    ...vender,
    description: `${vender.first_name} ${vender.last_name}`,
  }));

  return (
    <Dialog
      fullScreen
      open={visible}
      onClose={handleClose}
      TransitionComponent={Transition}
      style={{ zIndex: 2235 }}
    >
      <AppBar className="position-relative">
        <Toolbar>
          <button
            type="button"
            className="close-modal-button"
            onClick={handleClose}
          >
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">
            {formData.id > 0 ? "Update" : "Add"}
          </h4>
        </Toolbar>
      </AppBar>

      <div style={{ padding: "25px" }}>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6">
              <label htmlFor="date" className="form-label fw-bold">
                Date
              </label>
              <input
                type="date"
                className="form-control"
                id="date"
                onChange={handleInputChange}
                value={formData.date || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="short_description" className="form-label fw-bold">
                Short Description
              </label>
              <input
                type="text"
                className="form-control"
                id="short_description"
                onChange={handleInputChange}
                value={formData.short_description || ""}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-bold">Customer</label>
              <SingleCustomAutocomplete
                filedName="customer_id"
                list={updatedCustomers}
                value={formData.customer_id}
                listKey="id"
                description="description"
                customOnChange={customOnChange}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="notes" className="form-label fw-bold">
                Notes
              </label>
              <textarea
                className="form-control"
                id="notes"
                rows="3"
                onChange={handleInputChange}
                value={formData.notes || ""}
              />
            </div>

            <div className="col-12 text-end mt-4">
              {saveIsLoading ? (
                <CircularProgress />
              ) : (
                <button
                  className="btn btn-md btn-primary px-4"
                  onClick={saveForm}
                >
                  Save
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddUpdateSpecialDates;
